import styled from 'styled-components'

export const Container = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  align-self: center;
  min-height: 100vh;
  width: 100%;
  img {
    margin: 20px;
    width: 70%;
  }

  @media only screen and (min-width: 1000px) {
    img {
      width: 20%;
    }
  }
`
